import axios from '@fs/zion-axios'
import SERVICE from './serviceName'

// DOCS: https://icseng.atlassian.net/wiki/x/4Ir2Bw

const BASE = `${SERVICE}/session-metrics`
const config = { headers: { 'Content-Type': 'application/json' }, data: {} }
export const getUserSessionRating = async ({ sessionId, cisId }) => {
  return axios.get(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, config)
}

export const deleteUserSessionRating = async ({ sessionId, cisId }) => {
  return axios.delete(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, config)
}

export const getSessionMetrics = async ({ sessionId }) => {
  return axios.get(`${BASE}/sessions/${sessionId}`, config)
}
export const getSessionRatings = async ({ sessionId }) => {
  return axios.get(`${BASE}/sessions/${sessionId}/ratings`, config)
}

export const getUserRatings = async () => {
  return axios.get(`${BASE}/sessions`, config)
}

export const updateUserSessionRatings = async ({ sessionId, cisId }, body) => {
  return axios.put(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, body, config)
}

export const getTopSessionsByLanguage = async ({ lang }) => {
  return axios.get(`${BASE}/popular-sessions/${lang}`)
}
